import { render, staticRenderFns } from "./MallAd.vue?vue&type=template&id=41bebf96&scoped=true&"
import script from "./MallAd.vue?vue&type=script&lang=js&"
export * from "./MallAd.vue?vue&type=script&lang=js&"
import style0 from "./MallAd.vue?vue&type=style&index=0&id=41bebf96&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41bebf96",
  null
  
)

export default component.exports